import loadable from '@loadable/component';

export const VideoBannerEdit = loadable(
  () => import(/* webpackChunkName: "redturtle__qubicaamf-theme" */ './Edit'),
);
